/* eslint-disable jira/filename-case */
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type BackgroundScripts from './ui/index.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyForPaintBackgroundScripts: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof BackgroundScripts
>(
	() => import(/* webpackChunkName: "async-jira-dashboard-background-scripts" */ './ui/index.tsx'),
	{
		ssr: false,
	},
);
